import cx from 'classnames';

import { makeStyles } from '@mui/styles';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, breakpoints }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      [breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    iconContainer: {
      maxWidth: 80,
      width: '100%',
      height: 80,
      marginRight: spacing(2),
      marginBottom: 0,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    description: {
      margin: spacing(1, 0, 2, 0),
    },
    buttonContainer: {
      marginLeft: spacing(-2),
    },
  }),
  { classNamePrefix: 'UspItem' }
);
export default function UspItem({
  title,
  description,
  icon,
  className = '',
  button = null,
  titleComponent = 'h2',
}) {
  const classes = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      <div className={classes.iconContainer} aria-hidden="true">
        {icon}
      </div>
      <div className={classes.content}>
        <Typography variant="h4" component={titleComponent}>
          {title}
        </Typography>
        <Typography variant="body" className={classes.description}>
          {description}
        </Typography>
        {button && (
          <div className={classes.buttonContainer} data-testid="uspItemButton">
            {button}
          </div>
        )}
      </div>
    </div>
  );
}
